import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { Checkbox } from 'Components/Form';
import { Button } from 'Components/Button';
import ReactDOM from 'react-dom';

const InfoPopup = ({
  show,
  title,
  content,
  showCheckBox,
  checkBoxLabel,
  checkBoxChecked,
  onCheckBoxChange,
  buttonText,
  onButtonClick,
  onClose,
  icon
}) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="infoPopupOverlay">
      <div className="infoPopup">
        { icon || <Icon iconName="svgInfoGreen" /> }
        <h1>{ title }</h1>
        <p dangerouslySetInnerHTML={ { __html: content } } />
        { showCheckBox && (
          <div className="checkBoxArea">
            { checkBoxLabel }
            <Checkbox
              checked={ checkBoxChecked }
              onChange={ onCheckBoxChange }
            />
          </div>
        ) }
        <Button
          title={ buttonText }
          className="btn--primary"
          onClick={ onButtonClick }
        >
          { buttonText }
        </Button>
        <div onClick={ onClose } className="infoPopupCloseButton">
          <Icon iconName="svgCloseDeleteWhite" />
        </div>
      </div>
    </div>,
    document.getElementById('root')
  );
};

InfoPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  showCheckBox: PropTypes.bool,
  checkBoxLabel: PropTypes.string,
  checkBoxChecked: PropTypes.bool,
  onCheckBoxChange: PropTypes.func,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  icon: PropTypes.node
};


export default InfoPopup;
